import { ApolloError, useLazyQuery } from '@apollo/client';
import { IProductReview } from '@monofront/types';
import { GET_PRODUCT_REVIEWS_BY_CUSTOMER } from '../../queries/productReview';

interface IUseProductReviewByCustomerReturn {
  error: ApolloError | undefined;
  productReviewsByCustomer: IProductReview[];
  isLoading: boolean;
  getProductReviewsByCustomer: (skus: string[]) => void;
}

export const useGetProductReviewsByCustomer =
  (): IUseProductReviewByCustomerReturn => {
    const [getProductReviewsByCustomerQuery, { loading, data, error }] =
      useLazyQuery(GET_PRODUCT_REVIEWS_BY_CUSTOMER, {
        ssr: false,
        fetchPolicy: 'cache-and-network',
      });

    const getProductReviewsByCustomer = (skus: string[]): void => {
      getProductReviewsByCustomerQuery({
        variables: { skus },
      });
    };

    return {
      error,
      isLoading: loading,
      productReviewsByCustomer: data?.getProductReviewsByCustomer,
      getProductReviewsByCustomer,
    };
  };
